import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {

  constructor(private http:HttpClient) { }

  public sendForgotPasswordRequest(payload):Observable<any>{
    return this.http.post(environment.BASE_URL_PROFILE+'auth/forgotPassword',payload)
  }

  public sendUpdatePasswordRequest(payload):Observable<any>{
    return this.http.post(environment.BASE_URL_PROFILE+'auth/changePassword',payload)
  }
}
